// Fusi orari per i menu di scelta (nomi IANA, per esempio Europe/Rome). I browser recenti li elencano da soli;
// altrimenti vale un elenco ridotto. Il fuso già salvato compare sempre, anche se non è nell'elenco.
const FALLBACK_ZONES = [
  'Europe/Rome', 'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid', 'Europe/Zurich', 'Europe/Athens', 'Europe/Istanbul',
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Sao_Paulo', 'America/Mexico_City',
  'Asia/Dubai', 'Asia/Kolkata', 'Asia/Singapore', 'Asia/Tokyo', 'Australia/Sydney', 'Pacific/Auckland', 'UTC',
];

export function timezoneOptions(current) {
  let zones = FALLBACK_ZONES;
  try {
    if (typeof Intl.supportedValuesOf === 'function') {
      zones = Intl.supportedValuesOf('timeZone');
      if (!zones.includes('UTC')) zones = [...zones, 'UTC'];
    }
  } catch {
    zones = FALLBACK_ZONES;
  }
  return current && !zones.includes(current) ? [current, ...zones] : zones;
}
